//定义一个全局的函数,供JAVA调用
//jsonString可能是JSONObject，可直接使用
//jsonString格式如下。functionName要调用的函数的名称，params传递过去的参数
// {
//     "functionName":"onExitGame",
//     "params":{
//          "paramName1":1,
//          "paramName2":"xxx"
//     }
// }

window.onGetPlatformMsg = (jsonString) =>
{
    //业务逻辑
    console.log("receive message from JAVA:" + jsonString)
    var jsonObj = jsonString
    if (typeof(jsonString) == "string") 
    {
        jsonObj = JSON.parse(jsonString);
    }
    if(window.onHandlerPlatformMsg != null)
    {
        window.onHandlerPlatformMsg(jsonObj);//onHandlerPlatformMsg函数在SdkHandler.ts中注册了
    }else
    {
        console.log("onHandlerPlatformMsg未注册")
    }

}
